<template>
    <div class="rawMaterialConsume">
        <div class="filterConditions">
            <div class="time iconfont iconriqi" @click="startTimePicker = true">
                <input type="text" v-model="startTimeValue" readonly>
            </div>
            <template v-for="(item, index) in stationData">
                <van-button
                    :key="index"
                    type="default"
                    :class="{ active: stationIndex == index }"
                    @click="switchingStation(index, item)"
                >
                    {{ item.name }}
                </van-button>
            </template>
        </div>
        <van-popup v-model="startTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <section>
            <div class="statisticalData" v-if="unitPriceDat.length > 0">
                <template v-for="(item, index) in unitPriceDat">
                    <div :key="index">
                        <h3>{{ item.child_type_name }}</h3>
                        <p>{{ item.average_price }}<br>(元/吨)</p>
                    </div>
                </template>
            </div>
            <div class="tableBox">
                <div class="title">
                    <h4 class="van_left">
                        原材料消耗用量
                    </h4>
                    <span class="van_right">
                        单位：(千克/方)
                    </span>
                </div>
                <div class="tableList">
                    <table>
                        <template v-if="classificationData.materialConsume.length > 0">
                            <thead>
                                <tr>
                                    <th>产品标号</th>
                                    <th v-for="item in unitPriceDat" :key="'ctn'+item.child_type_name">
                                        {{ item.child_type_name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item,index) in classificationData.materialConsume">
                                    <tr :key="index">
                                        <th>{{ item.cpbh }}</th>
                                        <td v-for="(value,z) in item.values" :key="'bhz'+z">
                                            {{ value }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                        <tbody v-else>
                            <tr>
                                <td colspan="5">
                                    暂无数据
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'raw-material-consume',
    components: {},
    data() {
        return {
            // 开始时间
            startTimeValue: '',
            // 时间弹出层
            startTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 场站数据
            stationData: [
                { station_id: 'T200103000002', name: '青州' },
                { station_id: 'T200103000003', name: '东营' },
                { station_id: 'T200103000004', name: '济宁' },
            ],
            // 选中场站下标
            stationIndex: 0,
            // 选中场站id
            stationID: '',
            // 原材料单价数据
            unitPriceDat: {},
            // 各标号原材料分类消耗数据
            classificationData: {},
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        stationID() {
            this.getData();
        },
        filterData() {
            this.getData();
        },
    },
    computed: {},
    created() {
        // 开始时间
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.stationID = this.stationData[0].station_id;
        // 拉取场站数据
        // this.getStation();
    },
    mounted() {},
    methods: {
        // 获取数据
        async getData() {
            const data = await this.getSingleconsume(this.startTimeValue, this.stationID);
            this.unitPriceDat = data.materialPrices;
            this.classificationData.materialConsume = this.convertData(data.materialConsume);
        },
        // 处理接口数据
        convertData(data) {
            const result = [];
            if (data.length > 0) {
                data[0].singleConsumes.forEach(consume => {
                    result.push({
                        cpbh: consume.strength_grade_name, // 产品标号
                        values: [], // 产品标号对应的值
                    });
                });
                data.forEach(item => {
                    item.singleConsumes.forEach((consume, j) => {
                        result[j].values.push(consume.single_value);
                    });
                });
            }
            return result;
        },
        // 确认选择时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
            this.getData();
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 拉取场站
        getStation() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationData = stationList;
                this.stationID = stationList[0].station_id;
            }
        },
        // 切换场站
        switchingStation(index, item) {
            this.stationIndex = index;
            this.stationID = item.station_id;
        },

        // 获取场站
        getSingleconsume(date, tenant_id) {
            const data = {
                tenantId: tenant_id,
                date: date,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            const path = '/interfaceApi/report/consume/material/singleconsume';
            return this.$axios.$post(path, data);
        },
    },
};
</script>

<style scoped lang="stylus">
.rawMaterialConsume
    height 100%
    .filterConditions
        display flex
        height 60rpx
        padding 15rpx 10rpx
        border-bottom 2px solid #F0F0F0
        .time
            width 130rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            position relative
            input
                width 130rpx
                height 30rpx
                border none
                border 1px solid #D7D7D7
                border-radius 4rpx
                text-indent 30rpx
                font-size 14rpx;
            &:before
                line-height 30rpx
                font-size 16rpx
                color #979EA7
                position absolute
                left 5rpx
        .van-button
            width 60rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            padding 0
            font-size 12rpx
            color #666666
            border 1px solid #D7D7D7
            border-radius 4rpx
            box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
            &.active
                background #3495FB
                border-color #0E84FF
                color #fff
                box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 1)
    section
        .statisticalData
            height 73rpx
            display flex
            padding-top 10rpx
            >div
                width 25%
                text-align center
                &:nth-of-type(1)
                    h3
                        color #5588F1
                &:nth-of-type(2)
                    h3
                        color #FA8436
                &:nth-of-type(3)
                    h3
                        color #21BDCC
                &:nth-of-type(4)
                    h3
                        color #FFB729
            h3
                font-size 16rpx
                line-height 24rpx
            p
                font-size 12rpx
                line-height 13rpx
                color #979EA7
        .tableBox
            border-top 15rpx solid #F0F0F0
            padding 15rpx
            .title
                height 16rpx
                overflow hidden
                margin-bottom 10rpx
                h4
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                span
                    font-size 12rpx
                    height 16rpx
                    line-height 16rpx
                    color #979EA7
            .tableList
                table
                    width 100%
                    font-size 13rpx
                    th,td
                        font-weight 400
                        text-align center
                        height 40rpx
                        width 70rpx
                    th
                        background #EBF0FC
                        border 1px solid #DEE3EF
                        color #333333
                    td
                        background rgba(85, 136, 241, 0.04)
                        color #5588F1
</style>
